// Generated by CoffeeScript 1.11.1
(function() {
  var LayerInfo, PatternsData,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = PatternsData = (function(superClass) {
    extend(PatternsData, superClass);

    PatternsData.shouldParse = function(key) {
      return ['Patt', 'Pat2', 'Pat3'].includes(key);
    };

    function PatternsData(layer, length) {
      PatternsData.__super__.constructor.call(this, layer, length);
      this.length = length;
      this.patterns = {};
    }

    PatternsData.prototype.readVirtualMemoryArrayList = function() {
      var VMALEnd, byteCounts, chanPos, compressed, data, depth, endChannel, file, finish, i, j, k, l, len, lineIndex, m, n, pattern, ref, ref1, ref2, val;
      file = this.file;
      file.seek(4, true);
      VMALEnd = file.readInt() + file.tell();
      pattern = {
        top: file.readInt(),
        left: file.readInt(),
        bottom: file.readInt(),
        right: file.readInt(),
        channels: file.readInt(),
        data: []
      };
      pattern.width = pattern.right - pattern.left;
      pattern.height = pattern.bottom - pattern.top;
      for (i = k = 0, ref = pattern.channels + 2; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
        lineIndex = 0;
        chanPos = 0;
        if (!file.readInt()) {
          continue;
        }
        l = file.readInt();
        endChannel = l + file.tell();
        depth = file.readInt();
        file.readInt();
        file.readInt();
        file.readInt();
        file.readInt();
        file.readShort();
        compressed = file.readByte();
        if (compressed) {
          byteCounts = [];
          pattern.data[i] = new Uint8Array(pattern.width * pattern.height);
          for (j = m = 0, ref1 = pattern.height; 0 <= ref1 ? m < ref1 : m > ref1; j = 0 <= ref1 ? ++m : --m) {
            byteCounts.push(file.readShort());
          }
          for (j = n = 0, ref2 = pattern.height; 0 <= ref2 ? n < ref2 : n > ref2; j = 0 <= ref2 ? ++n : --n) {
            finish = file.tell() + byteCounts[lineIndex + j];
            while (file.tell() < finish) {
              len = file.read(1)[0];
              if (len < 128) {
                len += 1;
                data = file.read(len);
                pattern.data[i].set(data, chanPos);
                chanPos += len;
              } else if (len > 128) {
                len ^= 0xff;
                len += 2;
                val = file.read(1)[0];
                pattern.data[i].fill(val, chanPos, chanPos + len);
                chanPos += len;
              }
            }
          }
          lineIndex += pattern.height;
        } else {
          pattern.data[i] = new Uint8Array(file.read(l - 23));
        }
        file.seek(endChannel);
      }
      file.seek(VMALEnd);
      return pattern;
    };

    PatternsData.prototype.readPattern = function() {
      var file, len, mode, pattern, patternEnd, point, version;
      file = this.file;
      len = file.readInt();
      patternEnd = ((len + 3) & ~3) + file.tell();
      version = file.readInt();
      mode = file.readInt();
      point = [file.readShort(), file.readShort()];
      pattern = {
        name: file.readUnicodeString(),
        id: file.readString(file.readByte()),
        mode: mode,
        palette: [],
        width: point[1],
        height: point[0]
      };
      if (mode === 2) {
        pattern.palette = file.read(256 * 3);
        file.seek(4, true);
      }
      pattern.data = this.readVirtualMemoryArrayList();
      this.patterns[pattern.id] = pattern;
      return file.seek(patternEnd);
    };

    PatternsData.prototype.parse = function() {
      var file, patternsEnd;
      file = this.file;
      patternsEnd = this.length + file.tell();
      while (file.tell() < patternsEnd) {
        this.readPattern();
      }
      return file.seek(patternsEnd);
    };

    return PatternsData;

  })(LayerInfo);

}).call(this);
